<div class="pdf-overlay">
    <div class="container">
        <div class="btn-container">
            <button (click)="zoomIn()">
                <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z" />
                </svg>
            </button>
            <button (click)="zoomOut()">
                <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z" />
                </svg>
            </button>
            <button (click)="applyZoom(1);convertToPDF()">
                <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                </svg>
            </button>
            <div>
                <button (click)="closePdf()">
                    <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path
                            d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="pdf-container">
            <div id="contentToConvert" #pdfPage>
                <div class="header">
                    <h1>{{pdfVariables.companyDetails.name}}</h1>
                    <h2>Sales Inquery ({{pdfVariables.inqueryType}})</h2>
                </div>

                <div class="body">
                    <div class="customer_inquery">
                        <div class="customer-info">
                            <p><span>Customer: </span></p>
                            <div>
                                <p>{{pdfVariables.customerName}}</p>
                                <p>{{pdfVariables.customerDetails.addressLineOne}}</p>
                                <p>{{pdfVariables.customerDetails.addressLineTwo}}</p>
                                <p>{{pdfVariables.customerDetails.addressLineThree}}</p>
                                <p>{{pdfVariables.customerDetails.city}}</p>
                                <p>{{pdfVariables.customerDetails.country}}</p>
                                <p>{{pdfVariables.customerDetails.contact}}</p>
                            </div>
                            <p></p>
                        </div>
                        <div class="inquery-info">
                            <table>
                                <tr>
                                    <th> Inq No </th>
                                    <td>:</td>
                                    <td> {{pdfVariables.inqueryInfo.number}}</td>
                                </tr>
                                <tr>
                                    <th> Inq Date </th>
                                    <td>:</td>
                                    <td> {{pdfVariables.inqueryInfo.date}}</td>
                                </tr>
                                <tr>
                                    <th> Sales Rep. </th>
                                    <td>:</td>
                                    <td> {{pdfVariables.inqueryInfo.salesPerson}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="description-headers">
                        <table>
                            <tr>
                                <th>Job title: </th>
                                <td colspan="5">{{pdfVariables.descriptionHesders.jobTitle}}</td>
                            </tr>
                            <tr>
                                <th>No of Colors: </th>
                                <td>{{pdfVariables.descriptionHesders.noOfColors}}</td>

                                <th>Order type: </th>
                                <td>{{pdfVariables.descriptionHesders.orderType}}</td>
                            </tr>
                            <tr>
                                <th>Board: </th>
                                <td colspan="5">{{pdfVariables.descriptionHesders.board}}</td>
                            </tr>
                            <tr>
                                <th>Total Quantity: </th>
                                <td colspan="5">{{pdfVariables.descriptionHesders.totalQty}}</td>
                            </tr>
                            <tr>
                                <th>TIEP: </th>
                                <td>{{pdfVariables.descriptionHesders.tiep}}</td>

                                <th>FSC: </th>
                                <td>{{pdfVariables.descriptionHesders.fsc}}</td>

                                <th>Product Dimentions(L*W*H): </th>
                                <td>{{pdfVariables.descriptionHesders.ctnSize}} {{pdfVariables.descriptionHesders.lengthUnit}}</td>
                            </tr>
                            <tr>
                                <th>Remarks</th>
                                <td colspan="5">{{pdfVariables.descriptionHesders.remarks}}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="table">
                        <table>
                            <tr class="h-[20px]">
                                <th>Description</th>
                                <th>Order No</th>
                                <th>Qty</th>
                                <th>Pack Date</th>
                                <th>Exp Date</th>
                                <th>Batch No</th>
                                <th>Item No</th>
                            </tr>
                            <tr *ngFor="let item of pdfVariables.tblItems">
                                <td>{{item.description}} </td>
                                <td>{{item.orderNo}} </td>
                                <td>{{item.quantity}} </td>
                                <td>{{item.packingDate}} </td>
                                <td>{{item.expieryDate}} </td>
                                <td>{{item.batchNo}} </td>
                                <td>{{item.itemNo}} </td>
                            </tr>

                            <tr *ngIf="pdfVariables.inqueryType === 'Book' || pdfVariables.inqueryType === 'Tender'">
                                <td colspan="5">
                                    <span>Cover Page: </span> {{pdfVariables.book.coverPage}}
                                </td>
                                <td colspan="2">
                                    <span>Pages: </span> {{pdfVariables.book.coverPages}}
                                </td>
                                <!-- <td rowspan="2">
                                    <span>Pages: </span> {{pdfVariables.book.pages}}
                                </td> -->
                            </tr>
                            <tr *ngIf="pdfVariables.inqueryType === 'Book' || pdfVariables.inqueryType === 'Tender'">
                                <td colspan="5">
                                    <span>Inner Page: </span> {{pdfVariables.book.innerPage}}
                                </td>
                                <td colspan="2">
                                    <span>Pages: </span> {{pdfVariables.book.innerPages}}
                                </td>
                            </tr>
                            <!-- <tr>
                            <td rowspan="2">
                                <span>Pages: </span> {{pdfVariables.book.pages}}
                            </td>
                        </tr> -->
                        </table>
                    </div>

                    <div class="remarks">
                        <h1> <span> Special Finishings: </span> </h1>
                        <p *ngFor="let f of pdfVariables.finishings"> {{f}}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>